import { defineComponent as _defineComponent } from 'vue'
import { ButtonHTMLAttributes, computed, useSlots } from 'vue';
import { CButtonVariant } from '.';

type ButtonSize = 'md' | 'sm' | 'lg' | 'icon';


export default /*#__PURE__*/_defineComponent({
  __name: 'CButton',
  props: {
    text: null,
    icon: null,
    size: { default: 'md' },
    variant: null,
    disabled: { type: Boolean },
    type: { default: 'button' },
    prioritizeContent: { type: Boolean }
  },
  emits: ["click", "mousedown", "mouseup"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'click', value: MouseEvent): void;
    (event: 'mousedown', value: MouseEvent): void;
    (event: 'mouseup', value: MouseEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { text?: string, icon?: string | string[], size: ButtonSize, variant?: CButtonVariant, disabled?: boolean, type: ButtonHTMLAttributes['type'], prioritizeContent?: boolean };





const slots = useSlots();

const btnVariant = computed(() => (props.variant?.length ? props.variant : 'empty'));

return { __sfc: true,props, emit, slots, btnVariant }
}

})